module.exports = __webpack_public_path__ + "static/dan-burrell-409f9b8e2eebac947db37e06b577aa97.jpg";